module.exports = __webpack_public_path__ + "img/ec72e8b.svg";